<template>
  <svg
    width="44"
    height="44"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    style="display: block; margin: 0 auto 10px">
    <rect x="2" y="9" width="20" height="6" rx="1"></rect>
    <path d="M7 9V6.5a2.5 2.5 0 015 0V9M14 12h6M16 12v3"></path>
  </svg>
</template>
